import { render, staticRenderFns } from "./UserWallet.vue?vue&type=template&id=53be2e7c&scoped=true&"
import script from "./UserWallet.vue?vue&type=script&lang=js&"
export * from "./UserWallet.vue?vue&type=script&lang=js&"
import style0 from "./UserWallet.vue?vue&type=style&index=0&id=53be2e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be2e7c",
  null
  
)

export default component.exports